<template>
  <div class="home">
    <top></top>
    <Main></Main>
    <transition name="main" mode="out-in">
      <keep-alive>
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import Top from "./Top";
import Main from "./pages/Main";
import commonData from '../plugins/FetchCommonData/'
export default {
  components: {
    Top,
    Main,
  },
  created() {
    Promise.all([
      commonData('establishTime'),
      commonData('companyAge'),
      commonData('countSecurity'),
      commonData('countInvestment'),
      commonData('countInvestor'),
      commonData('countFutures'),
    ]).then(res => {
      let commonData = {
        establishTime: res[0] || '',
        companyAge: res[1] || '',
        countSecurity: res[2] || '',  // 证券公司数量
        countInvestment: res[3] || '',  // 投资机构数量
        countInvestor: res[4] || '',  // 期货投资者数量（万）
        countFutures: res[5] || '',  // 期货公司数量
      }
      this.$store.commit("setCommonData", commonData);
    })

    // 获取来源下拉列表
    this.$http.post("/api/dataapi/GetDengjiSource").then((res) => {

      if (res.status != 200 || !res.data) return;
      
      let sourceList = (res.data || []).map(item => {
        return {
          id: item.sourceid,
          value: item.sourcename,
        }
      });
      sourceList.unshift({ id: 16, value: '---' });
      
      this.$store.commit("setSourceList", sourceList);
    })
  }
};
</script>

<style scoped>
.home {
  height: 100%;
  width: 100%;
  -webkit-text-size-adjust: none;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
/* .body-wrap {
  top: 1.7rem;
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
} */
.main-enter-active,
.main-leave-active {
  transition: all 0.15s;
}

.main-enter,
.main-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>